// extracted by mini-css-extract-plugin
module.exports = {"nav":"constructor-navbar_nav__32gAg","nav_sectionLeft":"constructor-navbar_nav_sectionLeft__3Eo5n","nav_sectionRight":"constructor-navbar_nav_sectionRight__3n_M1"};